import { useRef, useState } from 'react';

import { Card } from 'react-bootstrap';
import downarrow from '../assets/icon/down-arrow.svg';
import './PricingModel.css';
const PricingModel = (props: any) => {
  const { tier, tierDescription } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const [hasScrolled, setHasScrolled] = useState(false);
 
  const handleScroll = () => {
    if (containerRef.current) {
      const isScrolled = containerRef.current.scrollTop > 0;
      setHasScrolled(isScrolled);
    }
  };
  return (
    <>
      <div>
        <Card
          className={`pricing-card ${hasScrolled && 'scrolled'}`}
          // style={{ width: '18rem', borderRadius: '5px',height:'200px' }}
          // onClick={handleShow}
          onScroll={handleScroll}
          ref={containerRef}>
          <Card.Body>
            <Card.Title>
              <h5 style={{ fontSize: '1rem' }}>{tier}</h5>
            </Card.Title>

            <Card.Subtitle className="mb-2 text-muted">
              <h5 style={{ fontSize: '1rem' }}>{tierDescription.pricing}</h5>
            </Card.Subtitle>

            <div className="price-details">
              <button
                className="btn uniBtnYellow m-2"
                style={{ width: '12rem' }}
                onClick={() => props.handleTier(props.tier)}>
                Subscribe
              </button>
            </div>


            <div className="card-body">
              <div className="info-container">
                <p style={{ fontWeight: 'bold' }}>Includes:</p>
                <ul className="text-start" style={{ listStyle: 'disc' }}>
                  {tierDescription.includes.map((items: any, index: number) => (
                    <li key={index}>
                      {items.title}
                      {items.subPoints && (
                        <ul>
                          {items.subPoints.map((subpoint: string) => (
                            <li>{subpoint}</li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
                <p style={{ fontWeight: 'bold' }}>Notes:</p>

                <ul className="text-start" style={{ listStyle: 'disc' }}>
                  {tierDescription.notes.map((items: any, index: number) => (
                    <li key={index}>
                      {items.title}
                      {items.subPoints && (
                        <ul>
                          {items.subPoints.map((subpoint: string, index: number) => (
                            <li key={index}>{subpoint}</li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Card.Body>
          {/* {<div className="see-more-text">See more <img src={downarrow} /> </div>} */}
        </Card>
      </div>
      
    </>
  );
};
export default PricingModel;
